import { Flex, Heading } from '@chakra-ui/react'
import { AutofillButton } from '../atoms/AutofillButton'
import { useTranslation } from 'next-i18next/pages'

export const VerifyFormTitle = ({
  mode,
  autofillEnabled = true,
}: {
  mode: 'drand' | 'drng'
  autofillEnabled?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <Flex mb={2} justifyContent={'space-between'}>
      <Heading fontSize={'xl'}>{t('verify.title')}</Heading>
      {autofillEnabled && <AutofillButton mode={mode} />}
    </Flex>
  )
}
